import React from 'react';

import Skel from '../skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import HomologationErrorIndicator from './homologation-error';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

/* eslint-disable complexity */

export default function VehicleDetails({
  vehicle = {},
  history = {},
  homologationError = null,
  historyPrefix = 'cab',
  title = 'Veículo'
}) {
  const hist = col => {
    const field = `${historyPrefix}${col.charAt(0).toUpperCase()}${col.substring(1)}`;
    return history[field];
  };

  const loading = !(vehicle.id || hist('plate'));

  return <>
    <Typography variant="subtitle1" component="h5" color="primary">
      {title}
    </Typography>

    <Grid container style={{ marginBottom: '9px'}} >
      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Placa
          </Typography>

          <Skel loading={loading}>{vehicle.plate || hist('plate')}</Skel>
        </div>
      </Grid>

      <HomologationErrorIndicator loading={loading} error={homologationError} />

      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Marca
          </Typography>

          <Skel loading={loading}>
            {
              vehicle.brand && vehicle.brand.description
              || hist('brand')
            }
          </Skel>
        </div>
      </Grid>

      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Modelo
          </Typography>

          <Skel loading={loading}>
            {vehicle.model ? vehicle.model.description : hist('model')}
          </Skel>
        </div>
      </Grid>

      {
        vehicle.type && (
          <Grid item sm={2}>
            <div className={styles.gridCell}>
              <Typography variant="subtitle2">
                Tipo
              </Typography>

              <Skel loading={loading}>
                {vehicle.type.description}
              </Skel>
            </div>
          </Grid>
        )
      }

      {
        vehicle.bodywork && (
          <Grid item sm={2}>
            <div className={styles.gridCell}>
              <Typography variant="subtitle2">
                Carroceria
              </Typography>

              <Skel loading={loading}>
                {vehicle.bodywork ? vehicle.bodywork.description : hist('bodywork')}
              </Skel>
            </div>
          </Grid>
        )
      }

      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Ano Fabricação/Modelo
          </Typography>

          <Skel loading={loading}>
            {vehicle.fabricationYear || hist('fabricationYear')}
            /
            {vehicle.modelYear || hist('modelYear')}
          </Skel>
        </div>
      </Grid>
    </Grid>

    <Grid container>
      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Placa (Registro)
          </Typography>

          <Skel loading={loading}>
            {
              [
                vehicle.plateCity && vehicle.plateCity.name,
                vehicle.plateState ? vehicle.plateState.name : hist('UF')
              ].filter(x => x && !!x.trim().length).join(' - ')
            }
          </Skel>
        </div>
      </Grid>

      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Renavam
          </Typography>

          <Skel loading={loading}>{vehicle.renavam || hist('renavam')}</Skel>
        </div>
      </Grid>

      <Grid item sm={3}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Chassi
          </Typography>

          <Skel loading={loading}>{vehicle.chassis || hist('chassis')}</Skel>
        </div>
      </Grid>

      <Grid item sm={2}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            ANTT
          </Typography>

          <Skel loading={loading}>{vehicle.antt || hist('antt') || '--'}</Skel>
        </div>
      </Grid>

      <Grid item sm={1}>
        <div className={styles.gridCell}>
          <Typography variant="subtitle2">
            Último Licenciamento
          </Typography>

          <Skel loading={loading}>{
            fmt.isoDate(vehicle.lastLicensing || hist('lastLicensing')) || '--'
          }</Skel>
        </div>
      </Grid>

      {
        vehicle.owner &&
          <Grid item md={12}>
            <div className={styles.gridCell}>
              <Typography variant="subtitle2">
                Proprietário do {title}
              </Typography>

              <Skel loading={loading}>
                {vehicle.owner ? vehicle.owner.name : hist('ownerName')}
              </Skel>
            </div>
          </Grid>
      }
    </Grid>
  </>;
}
